<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>
      {{titleInfo}}
    </div> 
    <div class="content whitebg" style="padding-top: 100px; padding-bottom: 80px;">  
      <el-form :label-position="position" label-width="200px" :model="formdata">
        <el-form-item label="联盟商家名称" prop="name">
          <el-input class="w300" v-model="formdata.name" placeholder="请输入联盟商家名称"></el-input>
        </el-form-item>
        <el-form-item label="绑定活动与套餐类型" prop="activity">
          <el-button size="small" @click="dialogActivity = true">选择活动与套餐类型</el-button>
          <div>
            <el-tag type="info" v-for="item in activity" :key="item.id">{{item.activity_title}}</el-tag>
          </div> 
        </el-form-item>
        <el-form-item label="联盟商家二选一" prop="type">
          <el-radio-group v-model="type">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选择联盟商家" v-if="type==1">
          <el-select class="w300" v-model="formdata.single_vid" placeholder="选择联盟商家" @change="onChange">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <!-- <el-cascader class="w300"
            placeholder="选择联盟商家"
            :options="options"
            :props="props"
            clearable
            @change="onChange">
          </el-cascader>           -->
        </el-form-item>
        <el-form-item label="佣金配置" prop="open_commission">
           <el-switch
                v-model="formdata.open_commission"
                active-color="#2AA3F8"
                inactive-color="#C0CCDA"
                :active-value="1"
                :inactive-value="0"
                >
            </el-switch> 
        </el-form-item>
        <el-form-item label="佣金比例分配" prop="" v-if="formdata.open_commission == 1">
            <el-table :data="tableData" border :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}"  :span-method="handleSameMerge" style="width: 60%;"  highlight-current-row  @current-change="handleCurrentChange" >
              <el-table-column label="活动名称"  prop="activity_title">
              </el-table-column>
              <el-table-column prop="title" label="套餐类型">
              </el-table-column>
              <el-table-column prop="boss_money" label="老板佣金比例" >
                <template slot-scope="scope">
                  <el-form :model="scope.row">
                    <el-form-item  >
                      <el-input-number v-model="scope.row.boss_money" style="width:100%;hight:100%" :min="0" :precision="2" :controls="false"  @blur='blurInput(scope.row.activity_id,scope.row.id,1,scope.row.boss_money,scope.row.final_commission)' ></el-input-number>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column prop="worker_money" label="员工佣金比例" >
                <template slot-scope="scope">
                  <el-form :model="scope.row">
                    <el-form-item >
                      <el-input-number  v-model="scope.row.worker_money" style="width:100%;hight:100%" :min="0" :precision="2" :controls="false"   @blur='blurInput(scope.row.activity_id,scope.row.id,2,scope.row.worker_money,scope.row.final_commission)'></el-input-number>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column prop="final_commission" label="佣金剩余总值" >
              </el-table-column>
            </el-table>
        </el-form-item>
        <el-form-item label="" v-if="formdata.open_commission == 1">
          <p>老板佣金+员工佣金总和必须小于等于佣金剩余总值</p>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain size="small" @click="goback"> 返回 </el-button>
          <el-button type="primary" size="small" @click="onGetQrcode">生成二维码</el-button>
        </el-form-item>
      </el-form>
    </div>
    <merchantDialog :visible.sync="dialogActivity" :type="0" @updatePageInfo="updatePageInfo"></merchantDialog>
    <merchantQrcodeDialog :visible.sync="dialogQrcode" :property="qrcode"></merchantQrcodeDialog>
  </div>
</template>

<script>
import merchantDialog from '@/components/tkdialog/merchantDialog';
import merchantQrcodeDialog from '@/components/tkdialog/merchantQrcodeDialog';
import api from "@/api.js";
export default {
  name: 'addOrEditMerchant',
  components: {
    merchantDialog, 
    merchantQrcodeDialog
  },
  data() {
    return {
      commission_config:[],
      tableData: [],
      tempIndex: [],
      list:[],
      titleInfo: '添加联盟商家',
      position: 'right',
      dialogQrcode: false,
      dialogActivity: false,
      formdata: {
        name: '',
        aids: '',
        single_vid: '',
        open_commission:0
      },
      options: [],
      activity: [],
      type: 1,
      qrcode: {},
      props: {
        multiple: true,
        value: 'id',
        label: 'name'
      },
   
    }
  },
  watch: {
      list: {
          handler(nv) {
              let arr = [];
              let tempMergeIndex = [];
              let pos;
              nv.forEach((item, i) => {
                  if (item.sku_list && item.sku_list.length) {
                      let sourceArr = item.sku_list.map(_ => {
                          return {
                              ..._,
                              flag: i + '',
                              activity_id: item.activity_id,
                              activity_title: item.activity_title,
                              boss_money:'0',
                              worker_money:'0'
                          };
                      });
                      arr.push(...sourceArr);
                  } else {
                      arr.push(item);
                  }
              });

              // console.log('pinjie',arr)
              this.tableData = arr;
              // 处理arr，生成一个与行数相同的数组记录每一行设置的合并数
              for (let i = 0; i < arr.length; i++) {
                  if (i === 0) {
                      tempMergeIndex.push(1);
                      pos = 0;
                  } else {
                      if (arr[i].flag && (arr[i].flag === arr[i - 1].flag)) {
                          tempMergeIndex[pos] += 1;
                          tempMergeIndex.push(0);
                      } else {
                          tempMergeIndex.push(1);
                          pos = i;
                      }
                  }
              }
              this.tempIndex = tempMergeIndex;
          },
          deep: true,
          immediate: true
      }
    },

  mounted() {
    this.axios
      .post(api.otherDifferentIndustry , {})
      .then(response => {
        if (response.data.code == 0) {
          this.options = response.data.result.list;
        } 
      }).catch(() => {})
  },
  methods: {
     handleCurrentChange(val) {
        
        // console.log('handleCurrentChange====',val)
        // this.currentRow = val;

      },
      // 当input失去光标后进行的操作
    async blurInput(aid, sku_id, name, value,money) {
      if(!money){
        money=0
      }
        let aa =sku_id
        var index = this.commission_config.findIndex(item => item.sku_id=== aa)
        // console.log('index',index)
        if(index != -1){
          if(name==1){
            if(!this.commission_config[index].worker_money){
              this.commission_config[index].worker_money  ='0'
            }
            if( parseFloat(value) + parseFloat(this.commission_config[index].worker_money) > parseFloat(money) ){
              this.$message.error('老板佣金与员工佣金的和必须小于'+ money );
              var index2 = this.tableData.findIndex(item => item.id=== aa)
              if(index2 != -1){

                  this.tableData[index2].boss_money = '0'
              }
               return
            }else{
                this.commission_config[index].boss_money = value
            }
           
           }
          if(name==2){
            if(!this.commission_config[index].boss_money){
              this.commission_config[index].boss_money  ='0'
            }
            if( parseFloat(value) + parseFloat(this.commission_config[index].boss_money) > parseFloat(money) ){
              this.$message.error('老板佣金与员工佣金的和必须小于'+ money );
              var index2 = this.tableData.findIndex(item => item.id=== aa)
              if(index2 != -1){
                  this.tableData[index2].worker_money = '0'
              }
               return
            }else{
              this.commission_config[index].worker_money = value
            }

          }
        }else{
            if(name==1){
              if( parseFloat(value) > parseFloat(money) ){
                this.$message.error('老板佣金与员工佣金的和必须小于'+ money );
                var index2 = this.tableData.findIndex(item => item.id=== aa)
                if(index2 != -1){
                    this.tableData[index2].boss_money = '0'
                }
                return
              }
              this.commission_config.push({aid:aid,sku_id:sku_id,boss_money:value})
            }
            if(name==2){
              if( parseFloat(value) > parseFloat(money) ){
                this.$message.error('老板佣金与员工佣金的和必须小于'+ money );
                var index2 = this.tableData.findIndex(item => item.id=== aa)
                if(index2 != -1){
                    this.tableData[index2].worker_money = '0'
                }
                return
              }
              this.commission_config.push({aid:aid,sku_id:sku_id,worker_money:value})
            } 
        }

      // console.log("===值改变了",aid)
      // console.log("===值改变了",sku_id)
      // console.log("===值改变了",name)
      // console.log("===值改变了",value)
      // console.log("===值改变了",money)
      // console.log("===值改变了",this.commission_config)
      },
  
    handleSameMerge({row, column, rowIndex, columnIndex}) {
          if (columnIndex === 0) {
              return {
                  rowspan: this.tempIndex[rowIndex],
                  colspan: 1
              };
          }
        },
    goback() {
      this.$router.go(-1);
    },
    updatePageInfo(option) {
      this.activity = option;
      if(this.activity){
        this.activity.forEach((item,index)=>{
          if(item.sku_list.length > 0){
            this.list.push(item)
          }
  
        })
      }
      // this.list =this.activity
      let arr = [];
      for (let i = 0; i < option.length; i++) {
        arr.push(option[i].activity_id);
      }
      this.formdata.aids = arr.join(',');
    },
    onChange(e) {
      this.formdata.single_vid = e;

    },
    // 生成二维码
    onGetQrcode() {
      if (!this.formdata.name) {
        this.$message.error('请输入联盟商家名称');
        return
      }
      if (!this.formdata.aids) {
        this.$message.error('请选择活动与套餐类型');
        return        
      }
      if (this.type == 1 && !this.formdata.single_vid) {
        this.$message.error('请选择联盟商家');
        return  
      }
      if( this.commission_config){
        this.formdata.commission_config = JSON.stringify(this.commission_config)
        // this.formdata.commission_config = this.commission_config
      }

      this.axios
        .post(api.addDifferentIndustry, this.formdata)
        .then(response => {
          if (response.data.code == 0) {
            this.qrcode = response.data.result;
            this.dialogQrcode = true;
          } 
        }).catch(() => {})
    }
  }
}
</script>